export function showCustomAlert(message) {
  const alertBox = document.createElement("div");
  alertBox.className =
    "fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50";
  alertBox.innerHTML = `
        <div class="bg-white p-6 rounded-lg shadow-xl max-w-sm w-full text-center">
            <p class="text-lg font-semibold text-gray-800 mb-4">${message}</p>
            <button class="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition duration-300">OK</button>
        </div>
    `;
  document.body.appendChild(alertBox);

  // Add event listener to close the alert
  alertBox.querySelector("button").addEventListener("click", () => {
    alertBox.remove();
  });
}
